

import { initialProfileDetails } from "./config/userDetails";
import { createSlice } from "@reduxjs/toolkit";

let initialUserDetails = {...initialProfileDetails}
const userSlice = createSlice({
    name: 'user',
    initialState: initialUserDetails,
    reducers: {
        setUserDetails: (state, action) => {
            return {
                ...state,
                ...action.payload.userDetails
            }
        },
        updateProfilePicture: (state, action) => {
            return {
                ...state,
                profilePicture: action.payload.profilePicture
            }
        },
        updateUserDetail: (state, action) => {
            delete action.payload.accountId
            return {
                ...state,
                ...(action.payload)
            }
        },
        resetUserDetails: (state: any) => {
            return {
                ...initialProfileDetails,
                recordId: state.recordId
            }
        }
    },
});

export const { setUserDetails, updateUserDetail, updateProfilePicture, resetUserDetails } = userSlice.actions;
export default userSlice.reducer;